import { Icon } from '@ipfabric/ui-components/Icon/Icon';
import { prop } from '@ipfabric/utils/fp/prop';
import { closeSidePanel } from 'components/Graph/commands/closeSidePanel';
import { showSidePanel } from 'components/Graph/commands/showSidePanel';
import type { FC } from 'react';
import { useGraphContextSelectors } from '../GraphContext';

export const GraphSideToggle: FC = () => {
  const ctxProps = useGraphContextSelectors({
    dispatch: prop('dispatch'),
    sidePanel: prop('sidePanel'),
  });

  const handleClick = () => {
    if (ctxProps.sidePanel.open) {
      ctxProps.dispatch(closeSidePanel);
    } else {
      ctxProps.dispatch(showSidePanel, {});
    }
  };

  return (
    <button
      className='graph-side-panel__toggle'
      type='button'
      onClick={handleClick}
    >
      <Icon
        size='lg'
        glyph={
          ctxProps.sidePanel.open
            ? 'fa-circle-arrow-left'
            : 'fa-circle-arrow-right'
        }
        iconStyle='solid'
      />
    </button>
  );
};
